<section class="p-20 max-w-520 mx-auto">
  <h1 class="heading-3 center bold">Something went wrong</h1>

  <p class="body center mt-32">An error has occurred. Please try again or contact us for support.</p>

  <section class="flex gap-12 mt-40 error-actions">
    <app-button
      dataLabel="contact-us"
      [buttonOptions]="{
        variant: 'secondary',
        isLink: true,
        url: 'https://www.domesticandgeneral.com/content/contact-domestic-general',
      }"
    >
      Contact us
    </app-button>
    <app-button
      dataLabel="dashboard"
      [buttonOptions]="{
        isLink: true,
        url: vm.dashboardLink,
      }"
    >
      Home
    </app-button>
  </section>
</section>
